import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { LegacyApiResponse, unwrapLegacyResult } from '../../../shared/utils/legacy-api-response.util';
import { unwrapV2, V2ApiResponse } from '../../../shared/utils/v2-api-response.util';
import { PaymentCardEntity, PaymentCardPayload } from '../models/payment-card-form.model';

@Injectable({ providedIn: 'root' })
export class PaymentCardCrudService {
  private readonly baseUrl = `${environment.apiUrl}/paymentcards`;

  constructor(private http: HttpClient) { }

  get(uid: string): Promise<PaymentCardEntity> {
    return unwrapV2(
      firstValueFrom(this.http.get<V2ApiResponse<PaymentCardEntity>>(`${environment.apiUrl}/api/v2/payment-cards/${encodeURIComponent(uid)}`)),
      'No se pudo cargar la tarjeta'
    );
  }

  create(payload: PaymentCardPayload): Promise<void> {
    return firstValueFrom(this.http.post<LegacyApiResponse<any>>(this.baseUrl, payload))
      .then(response => { unwrapLegacyResult(response, 'No se pudo crear la tarjeta'); });
  }

  update(uid: string, payload: PaymentCardPayload): Promise<void> {
    return firstValueFrom(this.http.put<LegacyApiResponse<boolean>>(`${this.baseUrl}/${encodeURIComponent(uid)}`, { ...payload, uid }))
      .then(response => { unwrapLegacyResult(response, 'No se pudo actualizar la tarjeta'); });
  }
}
